import React from 'react';
import PropTypes from 'prop-types';

import { getPredictorTrackingLabel, getIsAFLW } from '../utils';

const BettingOddsCell = ({ row, cell, cellProps, seasonPid }) => {
    const isAFLW = getIsAFLW(seasonPid);

    const trackOddsClick = (formattedOdds) => {
        /* eslint-disable camelcase */
        PULSE.app.tracking.recordEvent(
            PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT.CTA,
            {
                eventData: {
                    link_text: formattedOdds,
                    link_url: row.original.bettingOddsUrl,
                    outbound: true,
                    component_name: getPredictorTrackingLabel(
                        isAFLW,
                        'predictor odds link'
                    ),
                    component_type: 'odds link',
                    component_content_type: getPredictorTrackingLabel(
                        isAFLW,
                        'predictor'
                    )
                }
            }
        );
        /* eslint-enable camelcase */
    };

    if (row.allCells[0].value.eligible) {
        if (cell.value === 0) {
            return (
                <td {...cellProps} className="stats-table__betting-odds-cell" />
            );
        }

        const formattedOdds = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD'
        }).format(cell.value);

        return (
            <td {...cellProps} className="stats-table__betting-odds-cell">
                {row.original.bettingOddsUrl &&
                row.original.bettingOddsUrl !== '' ? (
                    <a
                        href={row.original.bettingOddsUrl}
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => trackOddsClick(formattedOdds)}
                    >
                        {formattedOdds}
                    </a>
                ) : (
                    <span>{formattedOdds}</span>
                )}
            </td>
        );
    }

    return (
        <td {...cellProps} className="stats-table__betting-odds-cell">
            <span>–</span>
        </td>
    );
};

export default BettingOddsCell;

BettingOddsCell.propTypes = {
    row: PropTypes.object,
    cell: PropTypes.object,
    cellProps: PropTypes.object,
    seasonPid: PropTypes.string
};
